<template>
  <button v-show="fullscreenEnabled" class="flex flex-center preview-fullscreen" @click="handleToggle">
    <Icon path="media" name="full" />
  </button>
</template>

<script>
import Icon from '@/components/icon'

export default {
  name: 'PreviewFullscreen',
  components: {
    Icon
  },
  props: {
    refName: {
      type: String,
      require: true,
      default: 'video'
    }
  },
  data() {
    return {
      isFullScreen: false,
      fullscreenEnabled: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const fullscreenEnabled = document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled

      this.fullscreenEnabled = fullscreenEnabled || false
    },
    handleToggle() {
      const el = this.$parent.$refs['video-container']
      if (this.isFullScreen) {
        const exitFullscreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitCancelFullScreen

        if (exitFullscreen) {
          exitFullscreen.call(document)
          this.isFullScreen = false
        }
      } else if (el) {
        const requestFullscreen = el.requestFullscreen || el.mozRequestFullScreen || el.webkitRequestFullScreen
        if (requestFullscreen) {
          requestFullscreen.call(el)
          this.isFullScreen = true
        }
      }
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');

  .preview-fullscreen {
    width: 46px;
    height: 40px;
    font-size: 26px;
    border-radius: 13px;
    transition: all linear .2s;
    &:hover {
      background-color: rgba(146, 159, 183, 0.5);
    }
  }
</style>>
